import { createUseStyles } from "react-jss";
import { ITheme } from "../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    overflowY: "scroll",
    overflowX: "hidden",
    scrollSnapType: "y mandatory",
    height: window.innerHeight,
    "-ms-overflow-style": "none" /* IE and Edge */,
    scrollbarWidth: "none" /* Firefox */,
    /* Hide scrollbar for Chrome, Safari and Opera */
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  content: {
    marginTop: 67,
    position: "relative",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space24,
  },
  earnGemBanner: {
    padding: `${theme.spacing.space32}px ${theme.spacing.space16}px 0px ${theme.spacing.space16}px`,
  },
  continuePlay: {
    gap: theme.spacing.space16,
    padding: `${theme.spacing.space16}px ${theme.spacing.space20}px`,
  },
  featureIframe: {
    position: "fixed",
    width: "100%",
    borderWidth: 0,
    height: "calc(100vh - 64px)",
    zIndex: theme.zIndex.appBar - 1,
    top: 64,
  },
}));
